/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Miniapp_Login_Hero_Image1Inputs */

const vi_sitesettings_miniapp_login_hero_image1 = /** @type {(inputs: Sitesettings_Miniapp_Login_Hero_Image1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh màn đăng nhập`)
};

/**

* @param {Sitesettings_Miniapp_Login_Hero_Image1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_miniapp_login_hero_image1 = /** @type {((inputs?: Sitesettings_Miniapp_Login_Hero_Image1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Miniapp_Login_Hero_Image1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_miniapp_login_hero_image1(inputs)
});
export { sitesettings_miniapp_login_hero_image1 as "siteSettings_miniapp_login_hero_image" }